// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import petitionEntity from './entities/petition.json';
import petitionMenu from '../pages/petition/menu.json';
import petitionFullForm from '../pages/petition/forms/full.json';
import petitionContextForm from '../pages/petition/forms/context.json';
import petitionMiniForm from '../pages/petition/forms/mini.json';
import petitionLookupForm from '../pages/petition/forms/lookup.json';
import petitionTableView from '../pages/petition/views/table.json';
import petitionStagesView from '../pages/petition/views/stages.json';
import petitionCardsView from '../pages/petition/views/cards.json';
import petitionInlineView from '../pages/petition/views/inline.json';
import petitionBacklogView from '../pages/petition/views/backlog.json';
import petitionSplitView from '../pages/petition/views/split.json';
import petitionCalendarView from '../pages/petition/views/calendar.json';
import petitionDashboardView from '../pages/petition/views/dashboard.json';

/** Тип запису «Петиція» зі сторінками пакета: меню, форми та подання з pages/petition/. */
export const petitionDefinition: IRecordTypeDefinition = {
  ...petitionEntity,
  views: assembleViewSet({
      table: petitionTableView,
      stages: petitionStagesView,
      cards: petitionCardsView,
      inline: petitionInlineView,
      backlog: petitionBacklogView,
      split: petitionSplitView,
      calendar: petitionCalendarView,
      dashboard: petitionDashboardView,
  }),
  form: petitionFullForm,
  forms: { full: petitionFullForm, context: petitionContextForm, mini: petitionMiniForm, lookup: petitionLookupForm },
  menu: petitionMenu,
} as IRecordTypeDefinition;
